export function configureCustomUnits(mathjs) {
    /**
     * These are SI *prefixes*, not units - doing this allowed us to extend the MathJS expression system to allow
     * dimensionless "count"-units. i.e. generally the metric system would treat `1.2m` as 1.2 meters not 1.2 "millis"
     * of an unspecified unit.
     *
     * MathJS has exactly this configuration built-in, but better (e.g. including ronna, ronto, quetta, and quecto), but
     * it distinguishes between units and prefixes (so, it won't produce a "unit" expression without a base unit, without
     * this hack).
     *
     * Also, MathJS won't move seamlessly between these units as it does for prefixes depending on the actual numeric quantity
     *
     * Under the hood MathJS is assigning a different "dimension" (a la length, mass, voltage) to each of these pseudo-units,
     * as if they represent different physical things - it does this by taking the unit name (e.g. milli) and appending
     * '_STUFF' (=10m is 10 MILLI_STUFFs)
     *
     * Luckily, the default "prefix" configuration option here is "none" - so SI prefixes are disabled for these
     * psuedo-units. This prevents the expression "100km" from representing 100,000 MILLI_STUFFs rather than 100 kilometers,
     * and "=2mm" from representing 0.002 MILLI_STUFFs
     */
    mathjs.createUnit?.({
        yocto: {
            definition: "0.000000000000000000000001",
            aliases: ["y", "Yocto"],
        },
        zepto: {
            definition: "0.000000000000000000001",
            aliases: ["z", "Zepto"],
        },
        atto: {
            definition: "0.000000000000000001",
            aliases: ["a", "Atto"],
        },
        femto: {
            definition: "0.000000000000001",
            aliases: ["f", "Femto"],
        },
        pico: {
            definition: "0.000000000001",
            aliases: ["p", "Pico"],
        },
        nano: {
            definition: "0.000000001",
            aliases: ["n", "Nano"],
        },
        micro: {
            definition: "0.000001",
            aliases: ["μ", "u", "Micro"],
        },
        milli: {
            definition: "0.001",
            aliases: ["m", "Milli"],
        },
        centi: {
            definition: "0.01",
            aliases: ["c", "Centi"],
        },
        deci: {
            definition: "0.1",
            aliases: ["d", "Deci"],
        },
        deca: {
            definition: "10",
            aliases: ["da", "Deca"],
        },
        hecto: {
            definition: "100",
            aliases: ["h", "Hecto"],
        },
        kilo: {
            definition: "1000",
            aliases: ["k", "Kilo", "K"],
        },
        mega: {
            definition: "1000000",
            aliases: ["M", "Mega"],
        },
        giga: {
            definition: "1000000000",
            aliases: ["G", "Giga"],
        },
        tera: {
            definition: "1000000000000",
            aliases: ["T", "Tera"],
        },
        peta: {
            definition: "1000000000000000",
            aliases: ["P", "Peta"],
        },
        exa: {
            definition: "1000000000000000000",
            aliases: ["E", "Exa"],
        },
        zetta: {
            definition: "1000000000000000000000",
            aliases: ["Z", "Zetta"],
        },
        yotta: {
            definition: "1000000000000000000000000",
            aliases: ["Y", "Yotta"],
        },
    }, {
        override: true,
    });
    // This is going beyond Math.js official API, but here we assign the uppercase 'K' prefix the same meaning as lowercase 'k
    mathjs.Unit.PREFIXES.SHORT["K"] = mathjs.Unit.PREFIXES.SHORT["k"];
}
//# sourceMappingURL=CustomUnits.js.map